module.exports = {
	"sidebar.section.main_menu": "เมนูหลัก",
	"sidebar.dashboard": "Dashboard",
	"sidebar.report": "รายงาน",
	
}
